// frontend/src/config/api/endpoints/superAdminEndpoints.ts
/**
 * Pensado por: Alcélio Gomes
 * Codificado em coautoria: Claude Code
 * 🚀 NeuroAgentes
 * 
 * AUDITORIA: Endpoints do módulo Super Admin.
 */

export const superAdminEndpoints = {
  dashboardMetrics: '/api/super-admin/dashboard/metrics',
  users: '/api/super-admin/users',
  updateUserRole: (userId: string) => `/api/super-admin/users/${userId}/role`,
  updateUserStatus: (userId: string) => `/api/super-admin/users/${userId}/status`,
  projects: '/api/super-admin/projects',
  updateProjectStatus: (projectId: string) => `/api/super-admin/projects/${projectId}/status`,
  deleteProject: (projectId: string) => `/api/super-admin/projects/${projectId}`,
  agents: '/api/super-admin/agents',
  updateAgentStatus: (agentId: string) => `/api/super-admin/agents/${agentId}/status`,
  deleteAgent: (agentId: string) => `/api/super-admin/agents/${agentId}`,
  systemGeneral: '/api/super-admin/system/general',
  systemSecurity: '/api/super-admin/system/security',
  maintenanceSettings: '/api/super-admin/system/maintenance/settings',
  maintenanceStatus: '/api/super-admin/system/maintenance/status',
  runMaintenance: '/api/super-admin/system/maintenance/run',
  configsByCategory: (category: string) => `/api/super-admin/system/configs/${category}`,
  updateConfig: '/api/super-admin/system/config',
};
